export default "__VITE_ASSET__B9fcAY1___"